<template>
  <section class="employee-free-dates-controls-list">
    <div
      v-for="employee in employees"
      v-bind:key="employee.id"
      v-on:submit.prevent
    >
      <div class="employee-free-dates-controls__head">
        {{ employee.name }}
        <span>
          {{ employee.speciality ? ` - ${employee.speciality}` : '' }}
        </span>
      </div>
      <expandable-block v-bind:max-height="75">
        <div class="employee-free-dates-controls employee-free-dates-controls-list__item">
          <button
            v-for="(date, index) in employee.dates"
            v-bind:key="index"
            class="employee-free-dates-controls__button"
            type="button"
            v-on:click="onDateSelected(date, employee.id)"
          >{{ formatDateToDayAndMonth(date) }}</button>
        </div>
      </expandable-block>
    </div>
  </section>
</template>
<script>
import ExpandableBlock from '@/components/ExpandableBlock.vue';

/**
 * @description Список сотрудников для управлением рабочим временем.
 * @type {Vue}
 */
export default {
  components: {
    ExpandableBlock,
  },
  methods: {
    /**
     * @description Обработать выбор свободной даты.
     * @param {string} date Дата в формате ISO.
     * @param {number} employeeId Идентификатор сотрудника.
     * @returns {void}
     */
    onDateSelected(date, employeeId) {
      if (this.$route.params.id !== employeeId.toString()
      || this.$route.query.day !== date
      || this.$route.query.period !== 'day') {
        this.$router.push({
          name: 'ClinicPanelAppointmentScheduleEmployeePeriod',
          params: { id: employeeId.toString() },
          query: { day: date, period: 'day' },
        });
      }
    },
    /**
     * @description Получить день и месяц из даты в формате ISO.
     * @param {string} dateISO Дата в формате ISO.
     * @returns {string}
     */
    formatDateToDayAndMonth(dateISO) {
      const fields = dateISO.split('-');
      return `${fields[2]}.${fields[1]}`;
    },
  },
  name: 'EmployeeFreeDatesControlsList',
  props: {
    employees: {
      required: true,
      type: Array,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
.employee-free-dates-controls {
  &-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    &__item {
      display: flex;
      flex-flow: row wrap;
      gap: 10px;

    }
  }
  &__desc {
    color: var(--unfocus-color);
    font-size: .825rem;
  }
  &__head {
    flex: 0 1 min(12rem, 100%);
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 10px 0;
    span {
      color: #90a0b7;
      font-size: 16px;
    }
  }
  &__button {
    @include buttons.btn-blue(65px, 32px, 14px);
  }
}
</style>
